import { ISplitTemplateParam, ISplitTemplate, ISplitTemplateRec } from '../../../types/air-splitting/separate-bills/templates';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 分账管理 - 分账模板管理
 */
export async function querySplitTemplates(param: ISplitTemplateParam) {
  let data = [] as ISplitTemplate[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as ISplitTemplateParam;

  try {
    const { code, context, message } = await Http.get<{ data: ISplitTemplate[]; total: number }>(`${hostUrl}/disburse/rule/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: ISplitTemplate[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 分账管理 - 新增模板
 */
export async function addSplitTemplates(param: any) {

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/disburse/rule/add`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');

    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 空中分账 - 分账管理 - 删除模板
 */
export async function delSplitTemplates(id) {

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/disburse/rule/delete/${id}`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');

    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 空中分账 - 分账管理 - 修改模板
 */
export async function editSplitTemplates(param: any) {

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/disburse/rule/modify`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');

    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 空中分账 - 分账管理 - 模板详情
 */
export async function splitTemplatesDetail(params) {

  let data = {} as ISplitTemplateRec;

  try {
    const { code, context, message } = await Http.get<ISplitTemplateRec>(`${hostUrl}/disburse/rule/detail`, params);

    if (code === EAxiosResponseCode.Succeed) {

      data = context || {} as ISplitTemplateRec;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return data;

}
